export default "__VITE_ASSET__a8415acb__"